export class CurePopup extends HTMLElement {
  connectedCallback() {
    this.colors = [];
    this.steps = this.querySelectorAll('.cure__progression-step');
    this.cureFull = false;
    this.productQuantity = parseInt(this.getAttribute('data-product-quantity')) || 6;

    this.style.height = window.innerHeight + 'px';

    window.addEventListener('resize', () => {
      this.style.height = window.innerHeight + 'px';
    });

    this.addEventListener('quantity:increase', (event) => {
      this.currentIndex = this.currentIndex + 1;
      this.querySelector('[data-meal-selected]').innerHTML = (this.currentIndex * this.productQuantity).toString();
      this.colors.push(event.detail.flavourColor);
      this._setStepColor(event.detail.flavourColor);

      if (this.currentIndex === this.maxSteps) {
        this.cureFull = true;
      }

      this._toggleDisabled();
    });

    this.addEventListener('quantity:decrease', (event) => {
      this.currentIndex = this.currentIndex - 1;
      this.colors.splice(this.colors.indexOf(event.detail.flavourColor), 1);
      this.querySelector('[data-meal-selected]').innerHTML = (this.currentIndex * this.productQuantity).toString();

      Array.from(this.steps).forEach((item, index) => {
        if (this.colors[index]) {
          item.querySelector('span').setAttribute('data-bg-color', this.colors[index]);
        } else {
          item.querySelector('span').removeAttribute('data-bg-color');
          item.querySelector('span').style.width = '0';
        }
      })

      this.cureFull = false;
      this._toggleDisabled();
    });

    this.addEventListener('cross-sell:decrease', (event) => {
      this.globalPrice = this.globalPrice - event.detail.price;
    });

    this.addEventListener('cross-sell:increase', (event) => {
      this.globalPrice = this.globalPrice + event.detail.price;
    });

    this.addEventListener('product:added', () => {
      this.hidden = true;
      this.colors = [];

      Array.from(this.steps).forEach((item, index) => {
        item.querySelector('span').removeAttribute('data-bg-color');
        item.querySelector('span').style.width = '0';
      })

      this.querySelector('[data-meal-selected]').innerHTML = '0';

      if (this.querySelector('.cure-popup__footer-button-continue')) this.querySelector('.cure-popup__footer-button-continue').disabled = true;

      Array.from(this.querySelectorAll('.cure-item__meal-quantity')).forEach((item) => { item.classList.remove('active') });
      Array.from(this.querySelectorAll('.cure-popup__product-quantity')).forEach(el => el.value = 0);
      this.currentIndex = 0;
      Array.from(this.querySelectorAll('button[increase]')).forEach((item) => { item.disabled = false });
      Array.from(this.querySelectorAll('button[decrease]')).forEach((item) => { item.disabled = true });
      Array.from(this.querySelectorAll('.cure-popup__product')).forEach((item) => {
        let inputToClear = item.querySelector('input[name*="items[0][properties]"]');

        if (inputToClear) {
          inputToClear.value = '';
          inputToClear.disabled = true
        }
      });
      this.cureFull = false;
      this.globalPrice = this.price;
      this.querySelector('button[type="submit"]').classList.remove('is-loading');

      if (this.crossSellActive) {
        this.showCompositionStep();
      } else {
        this.querySelector('button[type="submit"]').disabled = true;
      }
    });

    if (this.crossSellActive) {
      this.querySelector('.cure-popup__form').addEventListener('scroll', () => {
        let categoriesNav = this.querySelector('.cure-products__categories ');
        if (this.querySelector('.cure-popup__content--cross-sell:not(hidden) > .cure-popup__products-wrapper').offsetTop < categoriesNav.offsetTop) {
          categoriesNav.classList.add('fixed');
        } else {
          categoriesNav.classList.remove('fixed');
        }

        for (let i = 0; i < this.querySelectorAll('.cure-popup__products--category').length; i++) {
          let block = this.querySelectorAll('.cure-popup__products--category')[i];
          let offSetHeight = 0;

          if (block) {
            offSetHeight += (block.offsetTop + block.offsetHeight);
          }

          if (offSetHeight > (categoriesNav.offsetTop + categoriesNav.offsetHeight)) {
            let linkActive = this.querySelectorAll('button[is="category-button"]')[i];

            for (let j = 0; j < this.querySelectorAll('button[is="category-button"]').length; j++) {
              this.querySelectorAll('button[is="category-button"]')[j].classList.remove('active');
            }

            if (linkActive) {
              linkActive.classList.add('active');
            }
            break;
          }
        }
      })
    }

    this.querySelector('button[type="submit"]').addEventListener('click', (event) => { event.currentTarget.classList.add('is-loading') });
  }

  get hidden() {
    return this.getAttribute('aria-hidden') === 'true';
  }

  set hidden(value) {
    this.setAttribute('aria-hidden', (value) ? 'true' : 'false');
  }

  set currentIndex(value) {
    this.setAttribute('data-current', value.toString());
  }

  get crossSellActive() {
    return this.getAttribute('data-cross-sell-active') === 'true';
  }

  get price() {
    return parseFloat(this.getAttribute('data-price'));
  }

  get globalPrice() {
    return parseFloat(this.getAttribute('data-global-price'));
  }

  set globalPrice(value) {
    this.setAttribute('data-global-price', value.toString());
    if (this.querySelector('.cure-popup__footer [data-price]')) this.querySelector('.cure-popup__footer [data-price]').innerHTML = value.toFixed(2).replace('.', ',') + ' €';
  }

  get currentIndex() {
    return parseInt(this.getAttribute('data-current'));
  }

  get maxSteps() {
    return parseInt(this.getAttribute('data-steps'));
  }

  // Set steps explicitly: toggling them flipped back to the cross-sell step when product:added fired twice
  showCompositionStep() {
    Array.from(this.querySelectorAll('[data-cross-sell]')).forEach((item) => {
      item.hidden = item.matches('.cure-popup__content--cross-sell, .cure-popup__footer--wrapper.cross-sell');
    });
  }

  _setStepColor(color) {
    let currentStepItem = this.steps[this.currentIndex - 1].querySelector('span');

    currentStepItem.setAttribute('data-bg-color', color);
    currentStepItem.style.width = '100%';
  }

  _toggleDisabled() {
    Array.from(this.querySelectorAll('button[increase]')).forEach((item) => { item.disabled = this.cureFull });
    this.querySelector('.cure-popup__footer button').disabled = !this.cureFull;
  }
}

export class CureForm extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();

    this.formElement.addEventListener('submit', this._submitForm.bind(this));

  }

  get formElement() {
    return this.querySelector('form');
  }

  get submitButtons() {
    return Array.from(this.formElement.elements).filter((element) => element.type === 'submit');
  }

  async _submitForm(event) {
    event?.preventDefault();

    if (this._isSubmitting) return;

    // Never add a pack without its composition
    const curePopup = this.closest('cure-popup');
    if (curePopup && !curePopup.cureFull) {
      this.submitButtons.forEach((button) => button.classList.remove('is-loading'));
      if (curePopup.crossSellActive) curePopup.showCompositionStep();
      return;
    }

    let formData = new FormData(this.formElement);

    /////////////////////////////////////////
    // GTM - Fix 
    // Delete items with quantity 0
    const allEntries = Array.from(formData.entries());
    const itemsToRemove = allEntries
      .filter(([key, value]) => key.match(/^items\[\d+\]\[quantity\]$/) && value === '0')
      .map(([key]) => key.match(/\[(\d+)\]/)[1]);

    allEntries
      .filter(([key]) => itemsToRemove.some(index => key.includes(`items[${index}]`)))
      .forEach(([key]) => formData.delete(key));

    // Reorganize item indexes to be consecutive
    const remainingEntries = Array.from(formData.entries());
    const itemEntries = remainingEntries.filter(([key]) => key.match(/^items\[\d+\]/));
    
    const itemsByIndex = {};
    itemEntries.forEach(([key, value]) => {
      const match = key.match(/^items\[(\d+)\]/);
      if (match) {
        const originalIndex = match[1];
        if (!itemsByIndex[originalIndex]) {
          itemsByIndex[originalIndex] = [];
        }
        itemsByIndex[originalIndex].push([key, value]);
      }
    });

    itemEntries.forEach(([key]) => formData.delete(key));

    let newIndex = 0;
    Object.keys(itemsByIndex).sort((a, b) => parseInt(a) - parseInt(b)).forEach(originalIndex => {
      itemsByIndex[originalIndex].forEach(([key, value]) => {
        const newKey = key.replace(/\[\d+\]/, `[${newIndex}]`);
        formData.append(newKey, value);
      });
      newIndex++;
    });
    // End GTM Fix
    /////////////////////////////////////////

    formData.append('items[0][properties][_cureId]', new Date().getHours() + '' + new Date().getMinutes() + '' + new Date().getSeconds());

    // Fix for free guide position
    let formDataFreeGuide = formData.get('items[0][properties][_free-guide]')
    if (formDataFreeGuide) {
      formData.delete('items[0][properties][_free-guide]');
      formData.append(`items[0][properties][_free-guide]`, formDataFreeGuide);
    }

    // Lock the form during the request so a double click cannot add the pack twice
    this._isSubmitting = true;
    this.submitButtons.forEach((button) => button.disabled = true);

    let response;

    try {
      response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    } finally {
      this._isSubmitting = false;
      this.submitButtons.forEach((button) => {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
    }

    if (response.ok) {
      // Collecte les produits sélectionnés pour Sentry
      const selectedProducts = [];
      const allEntries = Array.from(formData.entries());
      for (const [key, value] of allEntries) {
        if (key.startsWith('items[0][properties][_') && value) {
          selectedProducts.push(value);
        }
      }

      this.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          targetFrom: 'product-single',
          cureProducts: selectedProducts
        }
      }));

      this.formElement.reset();
    }
  }

  disconnectedCallback() {
    this._abortController.abort();
  }
}

export class QuantitySelector extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.inputElement = this.querySelector('input');
    this.quantityItem = this.parentElement.querySelector('.cure-item__meal-quantity');

    this.querySelector('button:first-of-type').addEventListener('click', () => (this._toggleQuantity('decrease')), { signal: this._abortController.signal });
    this.querySelector('button:last-of-type').addEventListener('click', () => (this._toggleQuantity('increase')), { signal: this._abortController.signal });
  }

  disconnectedCallback() {
    this._abortController.abort();
  }

  get minValue() {
    return parseInt(this.inputElement.min);
  }

  get maxValue() {
    return parseInt(this.inputElement.max);
  }

  get quantity() {
    return parseInt(this.inputElement.value);
  }

  get productTitle() {
    return this.getAttribute('data-title');
  }

  get controlledInput() {
    return document.getElementById(this.getAttribute('aria-controls'));
  }

  set quantity(quantity) {
    this.inputElement.value = quantity.toString();
  }

  _toggleQuantity(event) {
    this.quantity = (event === 'decrease') ? this.quantity - 1 : this.quantity + 1;
    this._toggleDisabled();
    this._setInputValue(this.quantity);

    if (this.quantity === 0) {
      this.quantityItem.classList.remove("active")
    } else {
      this.quantityItem.querySelector('[data-meal]').innerHTML = (parseInt(this.quantityItem.getAttribute('data-sell-buy')) * this.quantity).toString();
      this.quantityItem.classList.add("active");
    }

    this.dispatchEvent(new CustomEvent(`quantity:${event}`, {
      bubbles: true,
      detail: {
        flavourColor: this.inputElement.getAttribute('data-flavour-color')
      }
    }));
  }

  _setInputValue(quantity) {
    this.controlledInput.value = (quantity > 0) ? quantity + ': ' + this.productTitle : "";
    this.controlledInput.disabled = quantity === 0;
  }

  _toggleDisabled() {
    Array.from(this.querySelectorAll('button')).forEach((item) => {
      item.disabled = (item === this.querySelector('button:first-of-type')) ? this.quantity === this.minValue : this.quantity === this.maxValue;
    })
  }
}

export class CrossSell extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.inputElement = this.querySelector('input');
    this.quantityItem = this.parentElement.querySelector('.cure-item__meal-quantity');

    this.querySelector('button:first-of-type').addEventListener('click', () => (this._toggleQuantity('decrease')), { signal: this._abortController.signal });
    this.querySelector('button:last-of-type').addEventListener('click', () => (this._toggleQuantity('increase')), { signal: this._abortController.signal });
  }

  get quantity() {
    return parseInt(this.inputElement.value);
  }

  get price() {
    return parseFloat(this.getAttribute('data-cross-sell-price'));
  }

  set quantity(quantity) {
    this.inputElement.value = quantity.toString();
  }

  _toggleQuantity(event) {
    this.quantity = (event === 'decrease') ? this.quantity - 1 : this.quantity + 1;
    this._toggleDisabled();

    if (this.quantity === 0) {
      this.quantityItem.classList.remove("active")
    } else {
      this.quantityItem.querySelector('[data-meal]').innerHTML = (parseInt(this.quantityItem.getAttribute('data-sell-buy')) * this.quantity).toString();
      this.quantityItem.classList.add("active");
    }

    this.dispatchEvent(new CustomEvent(`cross-sell:${event}`, {
      bubbles: true,
      detail: {
        price: this.price
      }
    }));
  }

  _toggleDisabled() {
    Array.from(this.querySelectorAll('button')).forEach((item) => {
      item.disabled = (item === this.querySelector('button:first-of-type')) ? this.quantity === 0 : false;
    })
  }

  disconnectedCallback() {
    this._abortController.abort();
  }
}

export class TogglePopup extends HTMLElement {
  constructor() {
    super();

    this.buttonElement.addEventListener('click', () => {
      this.controlledElement.hidden = !this.controlledElement.hidden;

      if (this.controlledOverlay) this.controlledOverlay.setAttribute('aria-hidden', this.controlledOverlay.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
    });
  }

  get controlledElement() {
    return document.getElementById(this.buttonElement.getAttribute('aria-controls'));
  }

  get controlledOverlay() {
    return document.getElementById(this.buttonElement.getAttribute('data-overlay'));
  }

  get buttonElement() {
    return this.querySelector('button');
  }
}

export class PopupInfo extends HTMLElement {
  constructor() {
    super();
  }

  get hidden() {
    return this.getAttribute('aria-hidden') === 'true';
  }

  set hidden(value) {
    this.setAttribute('aria-hidden', (value) ? 'true' : 'false');
  }
}

export class ToggleCrossSell extends HTMLElement {
  constructor() {
    super();

    this.buttonElement.addEventListener('click', () => {
      this._toggleCrossSell();

      this.controlledElement.querySelector('.cure-popup__form').scrollTo({
        top: 0,
        left: 0,
      });
    });
  }

  _toggleCrossSell() {
    Array.from(this.controlledElement.querySelectorAll('[data-cross-sell]')).forEach((item) => {
      (item.hasAttribute('hidden')) ? item.removeAttribute('hidden') : item.setAttribute('hidden', '');
    })
  }

  get controlledElement() {
    return document.getElementById(this.buttonElement.getAttribute('aria-controls'));
  }

  get buttonElement() {
    return this.querySelector('button');
  }
}

export class ShowMoreButton extends HTMLElement {
  constructor() {
    super();

    this.buttonElement.addEventListener('click', this._showMore.bind(this));

    document.addEventListener('popup:toggle', (event) => {
      let overlay = document.getElementById('overlay');

      event.detail.popup.hidden = false;
      overlay.setAttribute('aria-hidden', (event.detail.hideOverlay) ? 'true' : 'false');
      overlay.setAttribute('aria-controls', this.buttonElement.getAttribute('aria-controls'));
    });
  }

  get handle() {
    return this.buttonElement.getAttribute('data-handle')
  }

  get controlledPopup() {
    return document.getElementById(this.buttonElement.getAttribute('aria-controls'));
  }

  get buttonElement() {
    return this.querySelector('button');
  }

  async _showMore() {
    const response = await fetch(`${Shopify.routes.root}products/${this.handle}?section_id=cure-product-info`, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    const responseText = await response.text();

    if (response.ok) {
      this.controlledPopup.innerHTML = responseText;

      this.dispatchEvent(new CustomEvent(`popup:toggle`, {
        bubbles: true,
        detail: {
          popup: this.controlledPopup
        }
      }));
    }
  }
}

export class CategoryButton extends HTMLElement {
  constructor() {
    super();

    this.buttonElement.addEventListener('click', () => { this._scrollToSection() });
  }

  get category() {
    return document.getElementById(this.buttonElement.getAttribute('data-category'));
  }

  get buttonElement() {
    return this.querySelector('button');
  }

  _scrollToSection() {
    let scrollY = 0;

    if (this.closest('.cure-popup__wrapper').querySelector('.cure-popup__header')) {
      scrollY = this.closest('.cure-popup__wrapper').querySelector('.cure-popup__header').offsetHeight;
    }

    if (this.closest('.cure-popup__form').querySelector('.cure-products__categories')) {
      scrollY += this.closest('.cure-popup__form').querySelector('.cure-products__categories').offsetHeight;
    }

    this.closest('.cure-popup__form').scrollTo({
      top: (this.category.offsetTop - 30) - scrollY,
      left: 0,
      behavior: 'smooth'
    })

    Array.from(this.closest('.cure-popup__form').querySelectorAll('.cure-products__categories-wrapper .button__categories')).forEach((item) => {
      if (item !== this) item.classList.remove('active');
    })

    this.buttonElement.classList.add('active');
  }
}

export class CureItemReviews extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('load', () => {
      if (this.querySelector('.jdgm-prev-badge')) {
        if (parseInt(this.querySelector('.jdgm-prev-badge').getAttribute('data-average-rating')) > 0) {
          this.querySelector('.jdgm-prev-badge__text').innerHTML = parseFloat(this.querySelector('.jdgm-prev-badge').getAttribute('data-average-rating')).toFixed(1).replace('.', ',');
        }
      }
    });
  }
}

if (!window.customElements.get('cure-popup')) {
  window.customElements.define('cure-popup', CurePopup);
}

if (!window.customElements.get('popup-info')) {
  window.customElements.define('popup-info', PopupInfo);
}

if (!window.customElements.get('cure-form')) {
  window.customElements.define('cure-form', CureForm);
}

if (!window.customElements.get('quantity-selector')) {
  window.customElements.define('quantity-selector', QuantitySelector);
}

if (!window.customElements.get('cross-sell')) {
  window.customElements.define('cross-sell', CrossSell);
}

if (!window.customElements.get('toggle-popup')) {
  window.customElements.define('toggle-popup', TogglePopup);
}

if (!window.customElements.get('toggle-cross-sell')) {
  window.customElements.define('toggle-cross-sell', ToggleCrossSell);
}

if (!window.customElements.get('show-more-button')) {
  window.customElements.define('show-more-button', ShowMoreButton);
}

if (!window.customElements.get('category-button')) {
  window.customElements.define('category-button', CategoryButton);
}

if (!window.customElements.get('cure-item-reviews')) {
  window.customElements.define('cure-item-reviews', CureItemReviews);
}